import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
// component, hooks
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import AccordionMain from "../../../../../../common/components/accordion/AccordionMain";
import AccordionSummaryTail from "./AccordionSummaryTail";
import AccordionDetailChildren from "./AccordionDetailChildren";
// store
import { StoreContext } from "../../../../../../store/StoreProvider";
import Act from "../../../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../../../config/CONSTANTS";
import urls from "../../../../../../api/project/ApiUrls";

// style

const GroupList = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [test, setTest] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  return (
    <Box>
      <AccordionMain
        accordionProps={{}}
        darkMode
        summaryChildren={{
          text: intl.formatMessage({
            id: "sna.sidebar.grouptool.grouplist",
            defaultMessage: "團隊列表",
          }),
          tail: <AccordionSummaryTail />,
        }}
        detailsChildren={<AccordionDetailChildren />}
        detailsProps={{}}
      />
    </Box>
  );
};

GroupList.propTypes = {};

GroupList.defaultProps = {};

export default GroupList;
